import Tabs from './components/tabs'

$(document).ready(function () {

  if($('.faq').length > 0) {
    new Tabs();
    // Collapse
    const collapse = document.querySelectorAll('.faq .collapse')
    collapse.forEach(element => {
      element.addEventListener('click', (e) => {
        const el = e.target
        if (el) {
          if (el.classList.contains('is-show')) el.classList.remove('is-show')
          else el.classList.add('is-show')
        }
      })
    })
  }

});